var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CustomerInformationsSummaryWidget.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3ff75128\"}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CustomerInformationsSummaryWidget.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerInformationsSummaryWidget.vue
// module id = 634
// module chunks = 1